import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Faq } from '../../pages/runtime-typechecker';
import style from './Faq.module.css';
import { setDateAsDatePlusN } from '../../utils/timeUtils';
import { Context } from '../../../src/AppContext';
import { CASE_OTHERS } from '../../constants/omniture';
import { getCmpFromUrl, isSSR, isWebView } from '../../utils/commonUtils';
type FaqProps = {
  type?: 'LLM' | undefined;
  trackTemplateEvent?: (eventWithValToTrack: string) => void;
  data: Faq[];
  fromCityCode?: string;
  toCityCode?: string;
  pageUrl: string;
  tripType?: string;
  useUrlInBookNow?: boolean;
  schemaFaqs?: Array<{ question: string; answer: string }>;
};
const FaqSection = ({
  type = undefined,
  trackTemplateEvent,
  data,
  useUrlInBookNow = false,
  pageUrl,
  fromCityCode = '',
  toCityCode = '',
  tripType = 'OW',
  schemaFaqs = []
}: FaqProps) => {
  const { omniUrlArgs } = React.useContext(Context);
  useEffect(() => {
    const otherOperators = document.getElementsByClassName(
      'operatorNameInOperatorTemplate'
    );
    for (let i = 0; i < otherOperators.length; i++) {
      const operatorName = otherOperators[i]['id'];
      otherOperators[i].addEventListener('click', () => {
        trackTemplateEvent &&
          trackTemplateEvent(`Cab_SEO_FAQ_${operatorName}_Click`);
      });
    }
    const faqTopRoutes = document.getElementsByClassName('faqRoute');
    for (let i = 0; i < faqTopRoutes.length; i++) {
      const routeName = faqTopRoutes[i]['id'];
      faqTopRoutes[i].addEventListener('click', () => {
        trackTemplateEvent &&
          trackTemplateEvent(`Cab_SEO_FAQ_${routeName}_Route_Click`);
      });
    }

    const list = document.getElementsByClassName('faqBookNowButton');
    for (let i = 0; i < list.length; i++) {
      list[i].addEventListener(`click`, e => {
        e.preventDefault();
        if (list[i].id.includes('faqBookNowButtonLLM')) {
          trackTemplateEvent &&
            trackTemplateEvent(
              `Cab_SEO_FAQ_LLM_Book_Now_Click_${
                list[i].id.split('faqBookNowButtonLLM_')[1]
              }`
            );
        } else {
          trackTemplateEvent &&
            trackTemplateEvent(`Cab_SEO_FAQ_Book_Now_Click`);
        }

        let redirectionUrl;
        if (useUrlInBookNow && pageUrl) {
          window.location = Object(pageUrl);
          return;
        }

        if (fromCityCode && toCityCode) {
          //when used in  route/route operator pages clicking book now will redirect to cabs listing page
          redirectionUrl = isWebView()
            ? `${setDateAsDatePlusN(
                `mmyt://react/?page=cabsListing&deeplink=true&to=${toCityCode}&from=${fromCityCode}&tripType=${tripType}&startDate=21-08-2020&${omniUrlArgs}${CASE_OTHERS}`
              )}`
            : `${setDateAsDatePlusN(
                `https://cabs.makemytrip.com/cabsListing?fromCity=${fromCityCode}&toCity=${toCityCode}&tripType=${tripType}&departDate=21-02-2020&pickupTime=10:00&${omniUrlArgs}${CASE_OTHERS}`
              )}`;
        } else {
          //when used in other pages book now will redirect to cabs landing  page
          redirectionUrl = isWebView()
            ? `mmyt://react/?page=cabs&deeplink=true&tripType=${tripType}&${omniUrlArgs}${CASE_OTHERS}`
            : `https://www.makemytrip.com/cabs?${omniUrlArgs}${CASE_OTHERS}&tripType=${tripType}`;
        }
        const cmp = getCmpFromUrl();
        redirectionUrl = `${redirectionUrl}&cmp=${cmp}`;
        window.location = Object(redirectionUrl);
      });
    }
  }, []);

  return (
    <>
      {type != 'LLM' && (
        <Helmet>
          <script type="application/ld+json">
            {`
            {
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": ${JSON.stringify([
              ...data.map(faq => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: `${faq.answer}${
                    trackTemplateEvent ? `<a href=${pageUrl}>Book Now</a>` : ``
                  }`
                }
              })),
              ...schemaFaqs.map(faq => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer
                }
              }))
            ])}
            }
          `}
          </script>
        </Helmet>
      )}
      <div
        className={`${style.faqWarp} ${
          !trackTemplateEvent ? 'epass__wrap' : ''
        }`}
      >
        {!trackTemplateEvent && (
          <h2>{`Frequently Asked Questions About ePass for Travel`}</h2>
        )}
        {data
          .filter(faq => faq.type === type)
          .map((faq, idx) => {
            const answerWithBookNow = faq.answer.concat(
              faq.type === 'LLM'
                ? ` <a style="white-space:nowrap;" href="https://www.makemytrip.com/cabs/" class="faqBookNowButton" id="faqBookNowButtonLLM_${faq.question}">Book Now</a>`
                : ` <a style="white-space:nowrap;" href="https://www.makemytrip.com/cabs/" class="faqBookNowButton" >Book Now</a>`
            );
            return (
              <div key={'faq_' + idx}>
                <div className={style.faqWrap__top__desk}>
                  <div className={style.qusAunWrap}>
                    <h3 className={style.qus}>{'Q: ' + faq.question}</h3>
                    <div className={`makeFlex`}>
                      <p className={style.aun}>{`A:`} </p>
                      <p
                        className={style.aun}
                        dangerouslySetInnerHTML={{
                          __html: `${
                            trackTemplateEvent ? answerWithBookNow : faq.answer
                          }`
                        }}
                      ></p>
                    </div>
                  </div>
                </div>

                <div
                  style={{ display: 'none' }}
                  className={style.faqWrap__top__mob}
                >
                  <div className={style.qusAunWrap}>
                    <h3 className={style.qus}>{faq.question}</h3>
                    <p
                      className={style.aun}
                      dangerouslySetInnerHTML={{
                        __html: `${
                          trackTemplateEvent ? answerWithBookNow : faq.answer
                        }`
                      }}
                    ></p>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default FaqSection;
